/* tslint:disable */
/* eslint-disable */
/**
 * Marco Email Parser API
 * Marco Email Parser API
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { CurrencyAmount } from './CurrencyAmount';
import {
    CurrencyAmountFromJSON,
    CurrencyAmountFromJSONTyped,
    CurrencyAmountToJSON,
    CurrencyAmountToJSONTyped,
} from './CurrencyAmount';

/**
 * 
 * @export
 * @interface RecomputeBookingCreditsRequest
 */
export interface RecomputeBookingCreditsRequest {
    /**
     * Target user for this internal api_search operation.
     * @type {string}
     * @memberof RecomputeBookingCreditsRequest
     */
    userId?: string;
    /**
     * 
     * @type {CurrencyAmount}
     * @memberof RecomputeBookingCreditsRequest
     */
    commissionableCost: CurrencyAmount;
    /**
     * 
     * @type {boolean}
     * @memberof RecomputeBookingCreditsRequest
     */
    usedGondolaCredits: boolean;
}

/**
 * Check if a given object implements the RecomputeBookingCreditsRequest interface.
 */
export function instanceOfRecomputeBookingCreditsRequest(value: object): value is RecomputeBookingCreditsRequest {
    if (!('commissionableCost' in value) || value['commissionableCost'] === undefined) return false;
    if (!('usedGondolaCredits' in value) || value['usedGondolaCredits'] === undefined) return false;
    return true;
}

export function RecomputeBookingCreditsRequestFromJSON(json: any): RecomputeBookingCreditsRequest {
    return RecomputeBookingCreditsRequestFromJSONTyped(json, false);
}

export function RecomputeBookingCreditsRequestFromJSONTyped(json: any, ignoreDiscriminator: boolean): RecomputeBookingCreditsRequest {
    if (json == null) {
        return json;
    }
    return {
        
        'userId': json['user_id'] == null ? undefined : json['user_id'],
        'commissionableCost': CurrencyAmountFromJSON(json['commissionable_cost']),
        'usedGondolaCredits': json['used_gondola_credits'],
    };
}

export function RecomputeBookingCreditsRequestToJSON(json: any): RecomputeBookingCreditsRequest {
    return RecomputeBookingCreditsRequestToJSONTyped(json, false);
}

export function RecomputeBookingCreditsRequestToJSONTyped(value?: RecomputeBookingCreditsRequest | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'user_id': value['userId'],
        'commissionable_cost': CurrencyAmountToJSON(value['commissionableCost']),
        'used_gondola_credits': value['usedGondolaCredits'],
    };
}

